function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import BoxHeader from './header';
import BoxContent from './content';
import BoxFooter from './footer';
import { ContextNested, getValidNestedChild } from '../../hooks/context-nested';

var Box = function Box(_ref) {
  var Tag = _ref.asTag,
      children = _ref.children,
      className = _ref.className,
      others = _objectWithoutProperties(_ref, ["asTag", "children", "className"]);

  var _contextNested = useContext(ContextNested);

  var _Tag = getValidNestedChild(_contextNested.isNestedInParent, Tag);

  return React.createElement(ContextNested.Provider, {
    value: {
      isNestedInParent: _Tag,
      isNestedInlink: Tag === 'a'
    }
  }, React.createElement(_Tag, _objectSpread({
    className: classNames('box', className)
  }, others), children));
};

Box.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  asTag: PropTypes.string
};
Box.defaultProps = {
  asTag: 'div'
};
Box.Header = BoxHeader;
Box.Content = BoxContent;
Box.Footer = BoxFooter;
export default withModifiers(Box);